export const EDIT_COACH_BUTTON_LABEL = "Edit";
export const PRINT_BUTTON_LABEL = "Print";
export const VIEW_BUTTON_LABEL = "View Data";



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/components/coach-row/constants.ts